import React, { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import SEO from "@/components/app/SEO";

const CONTACT_CATEGORIES = [
  { value: "general", label: "Question générale" },
  { value: "dossier", label: "Suivi de dossier" },
  { value: "paiement", label: "Paiement" },
  { value: "reclamation", label: "Réclamation" },
  { value: "donnees", label: "Données personnelles" },
  { value: "partenariat", label: "Partenariat courtier" },
  { value: "securite", label: "Signalement de sécurité" },
];

export function AboutPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <SEO title="À propos" description="Résiliation Express — service indépendant d'accompagnement à la résiliation de contrats et abonnements." canonical="/a-propos" />
      <h1 className="text-4xl font-bold tracking-tight mb-6">À propos</h1>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        <p>Résiliation Express est un service indépendant d'accompagnement administratif édité par la société Résiliation Express (SASU), immatriculée au RCS de Paris sous le SIREN 107 406 878.</p>
        <p>Notre mission : redonner du pouvoir aux consommateurs face à la multiplication des contrats et abonnements en France, en fournissant un annuaire à jour, un outil de génération de courriers conformes et un service d'envoi postal en recommandé avec archivage des preuves.</p>
        <p>Nous ne sommes affiliés à aucune compagnie d'assurance, aucun opérateur télécom, aucune banque ni aucun organisme référencé dans notre annuaire. Notre indépendance est essentielle : nous n'agissons que dans l'intérêt de l'utilisateur.</p>
        <p>Les paiements sont traités exclusivement via PayPal Business. Aucune donnée bancaire n'est stockée sur nos serveurs.</p>
      </div>
    </div>
  );
}

export function ContactPage() {
  const [form, setForm] = useState({ category: "general", name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé");
      setSent(true);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de l'envoi");
    }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <SEO title="Contact" description="Contactez Résiliation Express — support, réclamations, partenariats, données personnelles, sécurité." canonical="/contact" />
      <h1 className="text-4xl font-bold tracking-tight mb-4">Contact</h1>
      <p className="text-muted-foreground mb-8">Une question ? Choisissez la catégorie la plus adaptée. Notre équipe vous répond sous 48h ouvrées.</p>
      {sent ? (
        <div className="card-elevated p-8 text-center" data-testid="contact-sent">
          <div className="font-semibold mb-2">Merci !</div>
          <div className="text-sm text-muted-foreground">Votre message a été transmis à notre équipe.</div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4 card-elevated p-6" data-testid="contact-form">
          <div>
            <Label htmlFor="ct-cat">Catégorie</Label>
            <select id="ct-cat" value={form.category} onChange={upd("category")} className="w-full border border-border rounded-md px-3 py-2 text-sm bg-background" data-testid="contact-category">
              {CONTACT_CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="ct-name">Nom</Label>
              <Input id="ct-name" value={form.name} onChange={upd("name")} required data-testid="contact-name" />
            </div>
            <div>
              <Label htmlFor="ct-email">Email</Label>
              <Input id="ct-email" type="email" value={form.email} onChange={upd("email")} required data-testid="contact-email" />
            </div>
          </div>
          <div>
            <Label htmlFor="ct-subject">Sujet</Label>
            <Input id="ct-subject" value={form.subject} onChange={upd("subject")} required data-testid="contact-subject" />
          </div>
          <div>
            <Label htmlFor="ct-message">Message</Label>
            <Textarea id="ct-message" rows={6} value={form.message} onChange={upd("message")} required minLength={20} data-testid="contact-message" />
          </div>
          <Button type="submit" className="w-full bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="contact-submit-btn">Envoyer</Button>
        </form>
      )}
    </div>
  );
}
